<div class="section">
    <h4 class="title">Organization Management</h4>
    <div class="row">
        <div class="col-md-4">
            <div class="search-hero">
                <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                    [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
            </div>
        </div>
        <div class="col-md-8 text-right">
            <button type="button" class="btn btn-primary mr-0" (click)="client_form()">Add</button>
        </div>
    </div>
    <div class="doc-table">

        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
            [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['type']">

            <ng-template pTemplate="header">
                <tr class="thhead">
                    <th class="th-1">
                        S.No
                    </th>
                    <th>
                       Logo
                    </th>
                    <th>
                        System ID
                    </th>
                    <th>
                        Short code
                    </th>
                    <th>
                        Country
                    </th>
                    <th>
                        Billing Currency
                    </th>
                    <th>
                        Company Name
                    </th>
                    <th>
                        Company Type
                    </th>
                    <th>No of license</th>
                    <th style="width: 110px;text-align:center">
                        Action
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
                <tr class="tdrow">
                    <td>{{i+1}}</td>
                    <td><img src="{{item.logo}}" alt="" style="width: 40px;height: 40px;" /></td>

                    <td>{{item.Client_system_code}}</td>
                    <td>{{item.client_short_code}}</td>
                    <td>{{item.country}}</td>
                    <td>{{item.currency}}</td>
                    <td>{{item.Clinet_name}}</td>
                    <td>{{item.primary_accont}}</td>
                    <td>{{item.no_of_lincenese}}</td>
                    <td class="act">
                      <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" (click)="Delete(item._id)" pTooltip="Delete"></i>
                        <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true" (click)="client_form_view(item)"
                            pTooltip="Profile"></i>
                    </td>
                </tr>
            </ng-template>
         </p-table>  </div>

    </div>
</div>